module.exports = __webpack_public_path__ + "img/2.faf07fce.png";